/**
 * Is a new spin held off right now?
 *
 * One test, read by every spin gate (the play button, handleSpin, the rgsPlay
 * choke point, autoplay and turbo), so they can never disagree:
 *
 * - an init is still open — a spin beside it is answered 105 "timeout"
 *   (gameSettings.initRequestsInFlight, measured 2026-10-01);
 * - a mystery reveal is on the board — set and cleared only by the reveal run
 *   (animations.mysteryRevealActive). criticalAnimationPlaying is not enough:
 *   error recovery lowers it while a replayed reveal is still playing.
 *
 * @param {object} state Redux state.
 * @returns {boolean}
 */
export const spinHeldOff = (state) =>
  (state?.game?.initRequestsInFlight ?? 0) > 0 ||
  state?.animations?.mysteryRevealActive === true;
